import { render, staticRenderFns } from "./ReportFormatOption.vue?vue&type=template&id=2b47bda1&scoped=true"
import script from "./ReportFormatOption.vue?vue&type=script&lang=js"
export * from "./ReportFormatOption.vue?vue&type=script&lang=js"
import style0 from "./ReportFormatOption.vue?vue&type=style&index=0&id=2b47bda1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47bda1",
  null
  
)

export default component.exports